import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-initials-component',
  templateUrl: './initials-component.html',
})
export class InitialsComponent implements OnInit {
  @Input()
  control: FormControl;

  @Input()
  form: FormGroup;

  @Input()
  placeholder: string;

  prevInitials = '';

  firstInitial = true;

  constructor() {
  }

  ngOnInit(): void {
    this.control.valueChanges.subscribe(newValue => this.addDotsToInitials(newValue));
  }

  addDotsToInitials(newValue: string): void {
    if (this.firstInitial) {
      this.prevInitials = this.control.value
        ? this.control.value
        : '';
      this.firstInitial = false;
    }

    if (!newValue) {
      return;
    }

    const lastChar = newValue.charAt(newValue.length - 1);
    if (lastChar === '.') {
      return;
    }

    if (this.prevInitials && this.prevInitials.length > newValue.length) {
      this.control.patchValue(newValue.substring(0, newValue.length - 1));
    } else {
      this.control.patchValue(newValue.toUpperCase() + '.');
    }

    this.prevInitials = this.control.value;
  }
}
